import Header from '../../components/Header'
import HeaderImage from '../../images/header_bg_2.png'
import {MdEmail} from 'react-icons/md'
import {BsMessenger} from 'react-icons/bs'
import {IoLogoWhatsapp} from 'react-icons/io'




import './Contact.css'


const Contact = () => {
  return (
    <>
  <Header title="Get In Touch" image={HeaderImage}>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
  </Header>
    <section className='contact'>
    <div className='container contact-container'>
    <div className='contact__wrapper'>
    <a href="mailto:info@iy-sp.com" target="_blank" rel="noreferrer noopener"><MdEmail/></a> 
    <a href="http://m.me/iyengarstpete" target="_blank" rel="noreferrer noopener"><BsMessenger/></a> 
    <a href="https://wa.me/+0017274178309" target="_blank" rel="noreferrer noopener"><IoLogoWhatsapp/></a> 

    </div>
</div>
</section>

    </>  
  )
}

export default Contact